import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-errors js-form-validation__errors invalid-feedback" }
const _hoisted_2 = {
  key: 0,
  class: "list-unstyled"
}



interface ErrorItem {
    message: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormErrors',
  props: {
    errors: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-ignore


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errors.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error.message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})